/* The (old) AddressFormContainer with separate entry for each field */
import type { ComponentProps } from 'react';

import { FormContextConsumer } from '#/components/Form/FormContext';

import { AddressFormSeparateContainerInternal } from './AddressFormSeparateContainerInternal';

type AddressFormSeparateContainerProps = Omit<
  ComponentProps<typeof AddressFormSeparateContainerInternal>,
  | 'address'
  | 'clearErrors'
  | 'error'
  | 'errors'
  | 'namePrefix'
  | 'setFetchingAddress'
  | 'updateAddress'
>;

export function AddressFormSeparateContainer({
  index,
  ...restProps
}: AddressFormSeparateContainerProps) {
  const addressKey = index !== undefined ? `addresses.${index}` : 'address';
  return (
    <FormContextConsumer>
      {({
        clearErrors,
        updateValueWith,
        setFetchingAddress,
        errors,
        getValue,
      }) => (
        <AddressFormSeparateContainerInternal
          index={index}
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'Address ... Remove this comment to see the full error message
          address={getValue(addressKey)}
          namePrefix={addressKey}
          setFetchingAddress={setFetchingAddress}
          updateAddress={(update) => {
            updateValueWith(addressKey, (a) => ({ ...a, ...update }));
          }}
          clearErrors={clearErrors}
          error={errors[addressKey]}
          errors={errors}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...restProps}
        />
      )}
    </FormContextConsumer>
  );
}
